import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import type { ConfigKey } from '@/types';

import { API_ROUTES } from '@/query/routes';
import axiosInstance from '@/utils/api/axios-instance';
import { INITIAL_MAP_CONFIG } from '@/utils/constants/map';

type FetchMapConfigQueryOptions = Omit<
  UseQueryOptions<Record<ConfigKey, boolean>>,
  'queryKey' | 'queryFn'
>;

const useFetchMapConfig = (options?: FetchMapConfigQueryOptions) => {
  const queryKey = ['mapConfig'];

  return useQuery<Record<ConfigKey, boolean>>({
    queryKey,
    queryFn: async () => {
      const response = await axiosInstance.get(API_ROUTES.mapConfig);

      const fetchedConfig = response.data?.mapConfig || response.data;

      if (!fetchedConfig || Object.keys(fetchedConfig).length === 0) {
        return INITIAL_MAP_CONFIG;
      }

      return {
        ...INITIAL_MAP_CONFIG,
        ...fetchedConfig,
      };
    },
    staleTime: Infinity,
    ...options,
    retry: false,
  });
};

export default useFetchMapConfig;
